import { createFileRoute } from '@tanstack/react-router';
import { PortalSupport } from '@/features/portal/PortalAssistenza';

export const Route = createFileRoute('/_portal/portal/assistenza')({ component: PortalSupport });
